import { dateTime } from '../../../shared/packages/dateTime';

export const createDisabledDateGetter = ({ acceptance }) => {
  return (date) => {
    const { toDate, fromDate } = acceptance ?? {};
    const currentDate = dateTime();
    const fromDateTime = dateTime(fromDate);

    const startDate = fromDateTime.isBefore(currentDate, 'day')
      ? currentDate
      : fromDateTime;

    return (
      date.isBefore(startDate, 'day') || date.isAfter(dateTime(toDate), 'day')
    );
  };
};
